import _ from 'lodash'

/**
 * Helpers for transformRequest/Response options of $resource actions definitions.
 *
 * @type {ngService}
 */
export class TmrTransformResourceAction {
  static ngType = 'service'

  constructor($http) {
    'ngInject'
    Object.assign(this, { $http })
  }

  prependRequest(action, callback) {
    action.transformRequest =
      action.transformRequest ?? [].concat(this.$http.defaults.transformRequest)
    action.transformRequest.unshift(callback)
  }

  prependResponse(action, callback) {
    action.transformResponse =
      action.transformResponse ??
      [].concat(this.$http.defaults.transformResponse)
    action.transformResponse.unshift(callback)
  }

  appendRequest(action, callback) {
    action.transformRequest =
      action.transformRequest ?? [].concat(this.$http.defaults.transformRequest)
    action.transformRequest.push(callback)
  }

  appendResponse(action, callback) {
    action.transformResponse =
      action.transformResponse ??
      [].concat(this.$http.defaults.transformResponse)
    action.transformResponse.push(callback)
  }

  /**
   * Adds default values to a resource.
   *
   * @param {object} action A $resource action
   * @param {function} defaultValues A function that returns an object of $resource properties with values
   */
  defaultValues(action, defaultValues) {
    this.prependResponse(action, response => {
      ;(Array.isArray(response) ? response : [response]).forEach(resource =>
        _.defaults(resource, defaultValues())
      )
      return response
    })
  }
}
